var map = {
	"./august.mp3": "nZz4",
	"./golden_bird.m4a": "luhe",
	"./sensible.m4a": "nJfM"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "sX5c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio ^\.\/.*$
// module id = sX5c
// module chunks = 1